import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Trophy, Coins, Fire, ShareNetwork } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

const MEDAL = ["🥇", "🥈", "🥉"];

export default function PublicReferralLeaderboard() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/public/referral-leaderboard?limit=25")
            .then((r) => setRows(r.data.items || []))
            .catch(() => setRows([]))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="min-h-screen bg-paper" data-testid="referral-leaderboard-page">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
                <p className="text-[10px] font-black uppercase tracking-[0.2em] text-splash mb-2 flex items-center gap-1.5">
                    <Fire size={12} weight="fill" /> Top referrers · updated hourly
                </p>
                <h1 className="font-heading text-4xl sm:text-6xl font-black tracking-tighter mb-2">
                    Refer &amp; earn
                </h1>
                <p className="text-base sm:text-lg text-[#525252] mb-8 max-w-xl">
                    Every friend who joins earns you coins toward Pro features. The top 3 each
                    month get an <b>Amazon voucher</b>. Are you on the list?
                </p>

                <Link to="/candidate"
                      data-testid="leaderboard-join-cta"
                      className="btn-gradient inline-flex items-center gap-2 px-6 py-3 text-xs font-black uppercase tracking-wider mb-10">
                    <ShareNetwork size={14} weight="bold" /> Get your referral link
                </Link>

                {loading && <p className="text-sm text-[#A3A3A3]">Loading leaderboard…</p>}
                {!loading && rows.length === 0 && (
                    <div className="bg-white border border-[#E5E5E5] p-8 text-center">
                        <Trophy size={28} weight="regular" className="text-[#A3A3A3] mx-auto mb-2" />
                        <p className="text-sm text-[#525252]">
                            No referrers on the board yet — be the first!
                        </p>
                    </div>
                )}
                {rows.length > 0 && (
                    <div className="bg-white border border-[#E5E5E5]">
                        {rows.map((r) => (
                            <div key={r.rank} data-testid={`leaderboard-row-${r.rank}`}
                                 className={`flex items-center justify-between px-5 py-4 border-b border-[#F5F5F5] last:border-b-0 ${
                                     r.rank <= 3 ? "bg-splash/5" : ""
                                 }`}>
                                <div className="flex items-center gap-4 min-w-0">
                                    <span className="text-xl w-8 shrink-0 tabular-nums text-center">
                                        {r.rank <= 3 ? MEDAL[r.rank - 1] : <span className="text-xs font-black text-[#A3A3A3]">#{r.rank}</span>}
                                    </span>
                                    <p className="font-heading font-bold text-ink truncate">{r.display_name}</p>
                                </div>
                                <div className="flex items-center gap-6 shrink-0">
                                    <span className="text-xs text-[#525252]">
                                        <b className="text-ink text-base">{r.count}</b> referrals
                                    </span>
                                    <span className="inline-flex items-center gap-1 text-xs text-[#525252]">
                                        <Coins size={12} weight="fill" className="text-splash" />
                                        <b className="text-ink">{r.coins}</b>
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
